import { generateInternalEan13 } from "../../../utils/internalEan13";
import { appendOptionalItemLists } from "../../PharmacyMedicineAdd/utils/itemListFields";

export const RESEARCH_FIELD_DEFAULTS = {
	package: "Strip",
	productForm: "Other",
	packageQuantity: 10,
	regularPrice: 1,
};

const isPositiveNumber = (value) => {
	const num = Number(value);
	return Number.isFinite(num) && num > 0;
};

const getResearchMedicineQuantity = (medicine) => {
	const raw = medicine?.package_qty ?? medicine?.quantity ?? medicine?.packageQuantity;
	return isPositiveNumber(raw) ? Number(raw) : null;
};

const hasValue = (value) =>
	value !== null && value !== undefined && String(value).trim() !== "";

export const hasMissingResearchFields = (medicine) =>
	!hasValue(medicine?.package) ||
	!hasValue(medicine?.product_form) ||
	getResearchMedicineQuantity(medicine) === null ||
	!isPositiveNumber(medicine?.mrp);

export const buildResearchFieldPrefill = (medicine) => ({
	package: hasValue(medicine?.package)
		? medicine.package
		: RESEARCH_FIELD_DEFAULTS.package,
	productForm: hasValue(medicine?.product_form)
		? medicine.product_form
		: RESEARCH_FIELD_DEFAULTS.productForm,
	packageQuantity:
		getResearchMedicineQuantity(medicine) ??
		RESEARCH_FIELD_DEFAULTS.packageQuantity,
	regularPrice: isPositiveNumber(medicine?.mrp)
		? medicine.mrp
		: RESEARCH_FIELD_DEFAULTS.regularPrice,
	minQuantityAlert: "",
});

export const buildResearchAddPayload = (
	medicine,
	isOTC,
	clinicId,
	baseCurrency = "INR",
	overrides = {}
) => {
	const brandName = medicine?.name || "";
	const saltName =
		medicine?.salt_composition || medicine?.salt_composition_new || brandName;
	const packageVal = overrides.package ?? medicine?.package;
	const productFormVal = overrides.productForm ?? medicine?.product_form;
	const packageQty = Number(
		overrides.packageQuantity ??
			medicine?.package_qty ??
			medicine?.quantity ??
			medicine?.packageQuantity
	);
	const mrp = Number(overrides.regularPrice ?? medicine?.mrp);

	const payload = {
		clinicId,
		isOTC,
		brandName,
		manufacturer: medicine?.manufacturer || "—",
		package: packageVal,
		productForm: productFormVal,
		packageQuantity: packageQty,
		regularPrice: mrp,
		barcode: generateInternalEan13(clinicId),
		note: medicine?.note || "",
		minQuantityAlert: overrides.minQuantityAlert ?? "",
		currency: baseCurrency,
		tax: medicine?.tax || "",
	};

	if (!isOTC) {
		payload.saltName = saltName;
		payload.medicationId = medicine?._id || "";
	} else {
		payload.saltName = saltName || brandName;
	}

	appendOptionalItemLists(payload, medicine);

	return payload;
};

export const buildPurchaseRowFromResearch = (createdItem, medicine, isOTC) => {
	const packageQuantity = Number(
		createdItem?.packageQuantity ??
			medicine?.package_qty ??
			medicine?.quantity ??
			medicine?.packageQuantity
	);
	const regularPrice = Number(createdItem?.regularPrice ?? medicine?.mrp);

	return {
		...createdItem,
		_id: createdItem?._id || createdItem?.id,
		brandName: createdItem?.brandName || medicine?.name || "",
		saltName:
			createdItem?.saltName ||
			medicine?.salt_composition ||
			medicine?.salt_composition_new ||
			"",
		isOTC: createdItem?.isOTC ?? isOTC,
		manufacturer: createdItem?.manufacturer || medicine?.manufacturer || "",
		package: createdItem?.package || medicine?.package || "",
		packageQuantity,
		productForm: createdItem?.productForm || medicine?.product_form || "",
		regularPrice,
		tax: createdItem?.tax ?? medicine?.tax ?? 0,
		stkQuantity: 1,
		itemQuantity: packageQuantity,
		unitPrice: regularPrice,
		unitSalePrice: regularPrice,
		barcode: createdItem?.barcode || "",
		batchNo: "",
		manufacturingDate: "",
		expiryDate: "",
		discount: 0,
		taxPercentage: Number(createdItem?.tax ?? medicine?.tax) || 0,
		taxAmount: 0,
		CGSTPercent: 0,
		CGSTAmount: 0,
		SGSTPercent: 0,
		SGSTAmount: 0,
		IGSTPercent: 0,
		IGSTAmount: 0,
		VATPercent: 0,
		VATAmount: 0,
	};
};
